/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Guest_S2Inputs */

const en_lg_guest_s2 = /** @type {(inputs: Lg_Guest_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The guest enters a name and chooses **Request entry**. Review check-ins, then choose **Admit** or **Deny**. Every visit needs fresh approval while the host is connected and present.`)
};

const id_lg_guest_s2 = /** @type {(inputs: Lg_Guest_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamu mengisi nama dan memilih **Minta masuk**. Periksa daftar check-in, lalu pilih **Terima** atau **Tolak**. Setiap kunjungan membutuhkan persetujuan baru saat host tersambung dan hadir.`)
};

/**
* | output |
* | --- |
* | "The guest enters a name and chooses **Request entry**. Review check-ins, then choose **Admit** or **Deny**. Every visit needs fresh approval while the host i..." |
*
* @param {Lg_Guest_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_guest_s2 = /** @type {((inputs?: Lg_Guest_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Guest_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_guest_s2(inputs)
	return en_lg_guest_s2(inputs)
});